import { h, Component } from 'preact';
import cx from 'classnames';
import callWith from '@os/call-with';
import { Text } from 'preact-i18n';
import { trackingProvider, trackProps, DIMENSION } from '@cube/track';
import { Icon } from '@cube/blocks';
import Current from '../current';
import Alert from '../alert';
import delve from 'dlv';
import style from './style';

@trackingProvider({
	[DIMENSION.componentpath]: 'Weather'
})
export default class Weather extends Component {

	static defaultProps = {
		showFullForecastLink: true
	}

	render({
		conditions,
		currentUnit,
		trackingParams,
		weatherLink,
		alerts,
		airQuality,
		changeUnit,
		showFullForecastLink,
		showAlerts
	}) {
		const isCelsius = currentUnit === 'C' || currentUnit === 'c';

		return (
			<div>
				<div key="container" class={style.container}>
					<Current
						today={conditions}
						airQuality={airQuality}
						unit={currentUnit}
						changeUnit={changeUnit}
						trackingParams={trackingParams}
					/>
				</div>
				<div class={style.footer}>
					<div class={style.moreOn}>
						<a href={weatherLink} target="_blank" rel="noopener noreferrer"
							{...trackProps({
								[DIMENSION.componentpath]: 'AccuWeather'
							}, this.context)}
						>
							<Text id="accuWeather" />
						</a>
					</div>
					<div class={style.degreePicker}>
						<TempScaleButton
							changeUnit={changeUnit}
							isCelsius={isCelsius}
							unit="F"
							class={style.fahrenheit}
						/>
						<TempScaleButton
							changeUnit={changeUnit}
							isCelsius={isCelsius}
							unit="C"
							class={style.celsius}
						/>
					</div>
					{showFullForecastLink &&
						<div class={style.fullForecast}>
							<a
								href={weatherLink}
								target="_blank"
								rel="noopener noreferrer"
								{...trackProps({
									[DIMENSION.componentpath]: 'FullForecast'
								}, this.context)}
							>
								<span class={style.fullForcastText}><Text id="fullForecast" /></span>
								<span class={style.fullForcastIcon}><Icon name="navigate-right-cube" /></span>
							</a>
						</div>

					}
				</div>
				{alerts && alerts.description && showAlerts &&
					<Alert
						alertCount={delve(alerts, 'totalAlerts')}
						alertText={alerts.description}
						alertURL={weatherLink}
					/>
				}
			</div>
		);
	}
}

export function TempScaleButton ({ changeUnit, unit, isCelsius, ...props }) {
	const isActive = unit === 'C' && isCelsius || unit !== 'C' && !isCelsius;
	return (
		<div
			class={cx(style.tempScaleButton, props.class, (isActive ? style.active : ''))}
			onClick={callWith(changeUnit, unit)}
		>
			{unit}
		</div>
	);
}
